/**
 * The type of specific capabilities or skills that are assigned to an employee.
 */
export enum CapabilityType {
  /** The employee is allowed to perform banking operations. */
  BANKING = 'BANKING',

  /** The employee is allowed to have access to the key of the store. */
  KEY_HOLDER = 'KEY_HOLDER',

  /** The employee is capable of participating in a changeover. */
  FURNITURE_CHANGEOVER = 'FURNITURE_CHANGEOVER'
}

/**
 * Returns a list of all {@link CapabilityType} values.
 */
export function capabilityTypeValues(): CapabilityType[] {
  return Object.values(CapabilityType).map((capabilityType: Extract<typeof CapabilityType, string>) => capabilityType);
}
